<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Suppliers</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Filter Suppliers"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-checkbox
                            label="Active Only"
                            v-model="activeOnly"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm2>
                        <v-btn
                            color="success"
                            block
                            @click="editSupplier({ Active: true })"
                        >
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="suppliers"
                            :loading="loading"
                            :search="search"
                            must-sort
                            :rows-per-page-items="rowsPerPage"
                            :pagination.sync="pagination"
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID">
                                    <td>{{props.item.Name}}</td>
                                    <td>{{formatPhoneNumber(props.item.Phone)}}</td>
                                    <td>{{formatPhoneNumber(props.item.Fax)}}</td>
                                    <td>{{props.item.Email}}</td>
                                    <td>{{props.item.ContactPerson}}</td>
                                    <td>{{formatPhoneNumber(props.item.ContactPersonPhone)}}</td>
                                    <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                    <td>
                                        <v-btn
                                            color="warning"
                                            block
                                            @click="editSupplier(props.item)"
                                        >
                                            Edit
                                        </v-btn>
                                    </td>
                                    <!-- <td>
                                        <v-btn
                                            color="info"
                                            block
                                            @click="editSupplierProducts(props.item)"
                                        >
                                            Products
                                        </v-btn>
                                    </td> -->
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-dialog v-model="showEditSupplierProductsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <supplier-products :editedSupplier="editedSupplier"></supplier-products>
            </v-dialog>

            <v-dialog v-model="showEditDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark :disabled="saving" @click="cancelEditSupplier">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title v-if="editedSupplier && editedSupplier.ID">Edit Supplier</v-toolbar-title>
                        <v-toolbar-title v-else>Add New Supplier</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-form ref="editForm" v-model="editSupplierValid">
                        <v-layout class="dialog-content">
                            <v-flex xs12 md6 offset-md3>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            counter="100"
                                            maxlength="100"
                                            v-model="editedSupplier.Name"
                                            :rules="[rules.required]"
                                            label="Supplier Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            :rules="[rules.required, rules.phoneNumber]"
                                            :mask="phoneMask(editedSupplier.Phone)"
                                            v-model="editedSupplier.Phone" 
                                            label="Supplier Phone Number">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            :rules="[rules.faxNumber]"
                                            :mask="phoneMask(editedSupplier.Fax)"
                                            v-model="editedSupplier.Fax" 
                                            label="Supplier Fax Number">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            counter="100" 
                                            maxlength="100"
                                            :rules="[rules.required, rules.email]"
                                            v-model="editedSupplier.Email" 
                                            label="Supplier Email">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            counter="100" 
                                            maxlength="100"
                                            :rules="[rules.email]"
                                            v-model="editedSupplier.EmailSecondary" 
                                            label="Secondary Supplier Email">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            counter="100"
                                            maxlength="100"
                                            v-model="editedSupplier.ContactPerson"
                                            :rules="[rules.required]"
                                            label="Contact Person Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable 
                                            :rules="[rules.required, rules.phoneNumber]"
                                            :mask="phoneMask(editedSupplier.ContactPersonPhone)"
                                            v-model="editedSupplier.ContactPersonPhone" 
                                            label="Contact Person Phone Number">
                                        </v-text-field>
                                    </v-flex>
                                    
                                    <v-flex xs12>
                                        <v-checkbox label="Active" v-model="editedSupplier.Active"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap class="dialog-action-buttons">
                                    <v-flex xs12 sm6>
                                        <v-btn block color="error" :disabled="saving" @click="cancelEditSupplier">Cancel</v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-btn block color="success" :disabled="!editSupplierValid" :loading="saving" @click="saveEditedSupplier">Save</v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <error-alert :content="saveError" :display="saveError"></error-alert>
                                    </v-flex>
                                </v-layout>                            
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import formatters from "../../helpers/formatters";
import ErrorAlert from "../common/ErrorAlert"
import SupplierProducts from "./SupplierProducts";
import util from '@/services/util';

export default {
    components: {
        ErrorAlert,
        SupplierProducts
    },
    props: [
        
    ],
    data() {
        return {
            rowsPerPage: [20, 50, 100],
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "Name"
            },
            editedSupplier: {},
            showEditDialog: false,
            editSupplierValid: false,
            search: "",
            activeOnly: true,
            withDetailsOnly: true,
            rules: validationRules.rules,
            headers: [
                {
                    text: "Supplier",
                    value: "Name"
                },
                {
                    text: "Supplier Phone",
                    value: "Phone"
                },
                {
                    text: "Supplier Fax",
                    value: "Fax"
                },
                {
                    text: "Supplier Email",
                    value: "Email"
                },
                {
                    text: "Contact",
                    value: "ContactPerson"
                },
                {
                    text: "Contact Phone",
                    value: "ContactPersonPhone"
                },
                {
                    text: "Active",
                    value: "Active"
                },
                {
                    text: "", // edit button
                    sortable: false
                }
                // {
                //     text: "", // products button
                //     sortable: false
                // }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.supplierStore.loading;
        },
        loadError() {
            return this.$store.state.supplierStore.loadError;
        },
        saving() {
            return this.$store.state.supplierStore.saving;
        },
        saveError() {
            return this.$store.state.supplierStore.saveError;
        },
        suppliers() {
            return this.$store.state.supplierStore.suppliers.filter(s => s.Active || !this.activeOnly);
        },
        categories() {
            return this.$store.state.categoryStore.categories.filter(c => c.Active).sort(util.sortByName);
        },
        showEditSupplierProductsDialog() {
            return this.$store.state.supplierStore.products.showEditDialog;
        }
    },
    methods: {
        loadSuppliers() {
            // CDC: this.$store.dispatch("supplierStore/loadSuppliers");
            this.$store.dispatch("supplierStore/loadSuppliersAll", {allSuppliers: 'true'});
        },
        loadCategories() {
            this.$store.dispatch("categoryStore/loadCategories");
        },
        editSupplier(item) {
            this.$store.dispatch("supplierStore/clearSaveError");

            // show which fields are mandatory when opening the edit form
            this.$refs.editForm.validate();

            this.editedSupplier = Object.assign({}, item);

            this.showEditDialog = true;
        },
        editSupplierProducts(item) {
            this.editedSupplier = Object.assign({}, item);

            // load products and categories from scratch again to refresh their data (or if they were not loaded at all)
            this.$store.dispatch("productStore/loadProducts");
            this.$store.dispatch("categoryStore/loadCategories");

            // load the products for the selected supplier
            this.$store.dispatch("supplierStore/loadSupplierProducts", {id: this.editedSupplier.ID});
            this.$store.dispatch("supplierStore/showProductsEditDialog", {show: true});
        },
        cancelEditSupplier() {
            this.showEditDialog = false;
            this.editedSupplier = {};
        },
        saveEditedSupplier() {
            var that = this;

            this.$store.dispatch("supplierStore/saveSupplier", {
                supplier: this.editedSupplier,
                finally: function() {
                    if (that.$store.state.supplierStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditSupplier();
                    }
                }
            });
        },
        bsbMask(value) {
            return validationRules.bsbMask(value);
        },
        phoneMask(value) {
            return validationRules.phoneMask(value);
        },
        formatPhoneNumber(value) {
            return formatters.formatPhoneNumber(value);
        },
        formatBSB(value) {
            return formatters.formatBSB(value);
        }
    },
    created() {
        this.loadSuppliers();

        if (this.categories.length <= 0) {
            this.loadCategories();
        }
    }
};
</script>

<style>
    
</style>
